export const globalEnv = {
  version: process.env.REACT_APP_VERSION || '',
  apiBaseUrl: process.env.REACT_APP_API_URL || '',
};
